import { createSlice } from "@reduxjs/toolkit";
import cloneDeep from "lodash/cloneDeep";

const initState = {
  url: null,
  batchurls: [],
  currentIndex: null,
  name: "",
  scaleX: 1,
  scaleY: 1,
  rotation: 0,
  opacity: 1,
  metadata: "",
  orientation: "",
  current_TemplateID: null,
  extension: "",
  first: true,
  loader: false,
  corruptedCount: null,
  ImageCanvasExceeded: false,
};

export const imageSlice = createSlice({
  name: "mainImage",
  initialState: initState,
  reducers: {
    setImageUrl: (state, action) => {
      state.url = action.payload.url;
      state.name = action.payload.name;
      state.metadata = action.payload.metadata;
    },
    setImageData: (state, action) => {
      const new_data = action.payload;
      const updated_data = [...state.batchurls, new_data];
      state.batchurls = updated_data;
    },
    setBatchUrlImage: (state, action) => {
      state.url = state.batchurls[action.payload].url;
      state.name = state.batchurls[action.payload].name;
      state.metadata = state.batchurls[action.payload].metadata;
      state.extension = state.batchurls[action.payload].extension;
      state.currentIndex = action.payload;
      state.current_TemplateID = state.batchurls[action.payload].template;
      state.orientation = false;
    },
    skipBatchUrlImage: (state, action) => {
      var oldState = state.batchurls;
      oldState.splice(action.payload, 1);
      state.batchurls = oldState;

      state.url = oldState[action.payload - 1].url;
      state.name = oldState[action.payload - 1].name;
      state.metadata = oldState[action.payload - 1].metadata;
      state.currentIndex = action.payload - 1;
      state.current_TemplateID = oldState[action.payload - 1].template;
    },
    skipBatchUrlImageOne: (state) => {
      var oldState = state.batchurls;

      if (oldState.length > 0) {
        oldState.shift(); // Remove the first element
        state.batchurls = oldState;

        if (oldState.length > 0) {
          state.url = oldState[0].url; // Set properties from the new first element
          state.name = oldState[0].name;
          state.metadata = oldState[0].metadata;
          state.currentIndex = 0; // Reset currentIndex to 0
          state.current_TemplateID = oldState[0].template;
        } else {
          // Handle the case when oldState is now empty
          state.url = "";
          state.name = "";
          state.metadata = "";
          state.currentIndex = null;
          state.current_TemplateID = null;
        }
      }
    },

    removeBatchUrlImage: (state, action) => {
      var indexToRemove = action.payload.index;
      var isSetPrevious = action.payload.setPrevious;
      var previousIndex = indexToRemove && indexToRemove >= 1 ? 1 : 0;
      let updatedBatchUrls;
      if (state.batchurls.length > 0) {
        updatedBatchUrls = [
          ...state.batchurls.slice(0, indexToRemove), // Elements before the removed index
          ...state.batchurls.slice(indexToRemove + 1), // Elements after the removed index
        ];
        state.batchurls = updatedBatchUrls;
        state.corruptedCount += 1;

        if (isSetPrevious || !previousIndex) {
          state.url = updatedBatchUrls[indexToRemove - previousIndex].url;
          state.name = updatedBatchUrls[indexToRemove - previousIndex].name;
          state.metadata =
            updatedBatchUrls[indexToRemove - previousIndex].metadata;
          state.currentIndex = action.payload - previousIndex;
          state.current_TemplateID =
            updatedBatchUrls[indexToRemove - previousIndex].template;
        }
      } else {
        return { ...initState };
      }
    },
    setTemplateForImage: (state, action) => {
      // state.url = state.batchurls;
      if (action.payload.index >= 0) {
        var newImage = cloneDeep(state.batchurls[action.payload.index]);
        newImage.template = action.payload.tempID;
        state.batchurls[action.payload.index] = newImage;
        state.current_TemplateID = action.payload.tempID;
      } else {
        const updateBatch = state.batchurls?.map((url) => ({
          ...url,
          template: action.payload.tempID,
        }));

        state.batchurls = updateBatch;
      }
    },
    scaleImage: (state, action) => {
      state.scaleX = action.payload.scaleX;
      state.scaleY = action.payload.scaleY;
    },
    rotateImage: (state, action) => {
      state.rotation = action.payload.rotation;
    },
    opaqueImage: (state, action) => {
      state.opacity = action.payload.opacity;
    },
    setImageCanvasExceeded: (state, action) => {
      state.ImageCanvasExceeded = action.payload;
    },
    setOrientation: (state, action) => {
      state.orientation = action.payload;
    },
    setExtensionFile: (state, action) => {
      state.extension = action.payload;
    },
    setCurrentIndex: (state, action) => {
      state.currentIndex = action.payload;
    },
    setFirst: (state, action) => {
      state.first = action.payload;
    },
    ClearImage: (state) => {
      return { ...initState, ImageCanvasExceeded: state.ImageCanvasExceeded };
    },
    setLoader: (state, action) => {
      state.loader = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  setImageUrl,
  setImageData,
  setBatchUrlImage,
  scaleImage,
  rotateImage,
  opaqueImage,
  setOrientation,
  setTemplateForImage,
  skipBatchUrlImage,
  skipBatchUrlImageOne,
  setCurrentIndex,
  setFirst,
  setExtensionFile,
  ClearImage,
  setLoader,
  removeBatchUrlImage,
  setImageCanvasExceeded,
} = imageSlice.actions;

export default imageSlice.reducer;
